module.exports = __webpack_public_path__ + "static/media/tomb_ftm_lp.67951ce9.png";